var _circle, _circle2, _circle3, _path, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconApi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Flat"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#e0f7fa",
    height: 111,
    rx: 12,
    width: 125,
    x: 1.5,
    y: 1.5,
    style: {
      fill: "rgb(182, 244, 252)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.5 13.5v15h-125v-15a12 12 0 0 1 12-12h101a12 12 0 0 1 12 12z",
    fill: "#455a64",
    style: {
      fill: "rgb(41, 111, 205)"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    fill: "#e91e63",
    r: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 15.5,
    fill: "#cddc39",
    r: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 15.5,
    fill: "#ffc107",
    r: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m111.5 12.5h-16a3 3 0 0 0 0 6h16a3 3 0 0 0 0-6z",
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 82.75,
    fill: "#fff",
    r: 29.75
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#455a64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m104.55 74.342-3.815-.131a37.493 37.493 0 0 0 -4.717-11.4l2.6-2.786a3.314 3.314 0 0 0 -.079-4.6l-7.206-7.206a3.314 3.314 0 0 0 -4.605-.079l-2.795 2.6a37.468 37.468 0 0 0 -11.394-4.726l-.131-3.814a3.315 3.315 0 0 0 -3.308-3.2h-10.195a3.315 3.315 0 0 0 -3.313 3.2l-.131 3.815a37.493 37.493 0 0 0 -11.4 4.717l-2.786-2.6a3.314 3.314 0 0 0 -4.6.079l-7.206 7.206a3.314 3.314 0 0 0 -.079 4.6l2.608 2.794a37.509 37.509 0 0 0 -4.726 11.395l-3.814.131a3.315 3.315 0 0 0 -3.2 3.313v10.19a3.315 3.315 0 0 0 3.2 3.313l3.816.131a37.465 37.465 0 0 0 4.716 11.4l-2.6 2.786a3.314 3.314 0 0 0 .079 4.605l7.206 7.206a3.314 3.314 0 0 0 4.6.079l2.8-2.608a37.493 37.493 0 0 0 11.394 4.726l.131 3.814a3.315 3.315 0 0 0 3.313 3.2h10.187a3.315 3.315 0 0 0 3.313-3.2l.131-3.816a37.465 37.465 0 0 0 11.4-4.716l2.786 2.6a3.314 3.314 0 0 0 4.605-.079l7.206-7.206a3.314 3.314 0 0 0 .079-4.605l-2.608-2.795a37.493 37.493 0 0 0 4.726-11.394l3.814-.131a3.315 3.315 0 0 0 3.2-3.313v-10.182a3.315 3.315 0 0 0 -3.202-3.313zm-40.55 38.158a29.75 29.75 0 1 1 29.75-29.75 29.751 29.751 0 0 1 -29.75 29.75z",
    fill: "#455a64",
    style: {
      fill: "rgb(41, 111, 205)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.542 73.694a5.59 5.59 0 0 0 -5.584 5.584v9.722a1.5 1.5 0 0 0 3 0v-4.333h5.167v4.333a1.5 1.5 0 0 0 3 0v-9.722a5.59 5.59 0 0 0 -5.583-5.584zm2.583 7.973h-5.167v-2.389a2.584 2.584 0 1 1 5.167 0z",
    fill: "#455a64",
    style: {
      fill: "rgb(41, 111, 205)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.542 87.5h-2.584v-11h2.584a1.5 1.5 0 0 0 0-3h-8.167a1.5 1.5 0 0 0 0 3h2.583v11h-2.583a1.5 1.5 0 0 0 0 3h8.167a1.5 1.5 0 0 0 0-3z",
    fill: "#455a64",
    style: {
      fill: "rgb(41, 111, 205)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.858 73.5h-4.9a1.5 1.5 0 0 0 -1.5 1.5v14a1.5 1.5 0 0 0 3 0v-5.5h3.4a5 5 0 0 0 0-10zm0 7h-3.4v-4h3.4a2 2 0 0 1 0 4z",
    fill: "#455a64",
    style: {
      fill: "rgb(41, 111, 205)"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApi);
export default __webpack_public_path__ + "static/media/iconApi.8b101b943c9954ee416812402d2a3f3e.svg";
export { ForwardRef as ReactComponent };